import api from "../api";

const BASE_URL = "/partnerships";

export interface Partnership {
  createdAt?: string;
  description: string;
  featured?: boolean;
  hidden: boolean;
  id: string;
  isActive: boolean;
  logoUrl: string;
  order?: number;
  organizationName: string;
  partnershipType: string;
  updatedAt?: string;
  updatedBy?: string;
  website: string;
}

function mapPartnership(p: any, idx = 0): Partnership {
  return {
    createdAt: p.created_at,
    description: p.description,
    featured: !!p.featured,
    hidden: !!p.hidden,
    id: String(p.id),
    isActive: !p.hidden,
    logoUrl: p.logo_url ?? "",
    order: idx,
    organizationName: p.organization_name,
    partnershipType: p.partnership_type,
    updatedAt: p.updated_at,
    updatedBy: p.updated_by,
    website: p.website,
  };
}

export const PartnershipService = {
  create: async (data: Partnership, logoFile?: File): Promise<Partnership> => {
    const formData = new FormData();
    formData.append("organization_name", data.organizationName);
    formData.append("partnership_type", data.partnershipType);
    formData.append("description", data.description);
    formData.append("website", data.website);
    formData.append("featured", data.featured ? "1" : "0");
    formData.append("hidden", data.hidden ? "1" : "0");
    if (logoFile) {
      formData.append("logo", logoFile);
    }
    const response = await api.post(BASE_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return mapPartnership(response.data.partnership);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  feature: async (id: string): Promise<Partnership> => {
    const response = await api.post(`${BASE_URL}/${id}/feature`);
    return mapPartnership(response.data.partnership);
  },

  getAll: async (): Promise<Partnership[]> => {
    const response = await api.get(BASE_URL);
    return (response.data.partnerships || []).map(mapPartnership);
  },

  hide: async (id: string): Promise<Partnership> => {
    const response = await api.post(`${BASE_URL}/${id}/hide`);
    return mapPartnership(response.data.partnership);
  },

  unfeature: async (id: string): Promise<Partnership> => {
    const response = await api.post(`${BASE_URL}/${id}/unfeature`);
    return mapPartnership(response.data.partnership);
  },

  unhide: async (id: string): Promise<Partnership> => {
    const response = await api.post(`${BASE_URL}/${id}/unhide`);
    return mapPartnership(response.data.partnership);
  },

  update: async (
    id: string,
    data: Partnership,
    logoFile?: File,
  ): Promise<Partnership> => {
    const formData = new FormData();
    formData.append("organization_name", data.organizationName);
    formData.append("partnership_type", data.partnershipType);
    formData.append("description", data.description);
    formData.append("website", data.website);
    formData.append("featured", data.featured ? "1" : "0");
    formData.append("hidden", data.hidden ? "1" : "0");
    if (logoFile) {
      formData.append("logo", logoFile);
    }
    const response = await api.post(`${BASE_URL}/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return mapPartnership(response.data.partnership);
  },
};
